// **********************************************************
// Latest News Slider
// **********************************************************

const latestNewsSlider = document.querySelectorAll('[data-slider="latest-news-swiper"]');

const latestNewsSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'progressbar',
  },
  breakpoints: {
    767: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
};

const initLatestNewsSlider = (el) => {
  const parentEle = el.closest('.latest-news');

  const arrowRight = parentEle.querySelector('.arrow-right');
  const arrowLeft = parentEle.querySelector('.arrow-left');
  const pagination = parentEle.querySelector('.swiper-pagination');

  const options = {
    ...latestNewsSliderOptions,
    pagination: {
      ...latestNewsSliderOptions.pagination,
      el: pagination,
    },
    navigation: {
      prevEl: arrowLeft,
      nextEl: arrowRight,
    },
  };

  new Swiper(el, options);
};

latestNewsSlider.forEach((el) => initLatestNewsSlider(el));

setupResponsiveSliders({
  sliderElements: latestNewsSlider,
  breakpoint: breakpointSm,
  initSlider: initLatestNewsSlider,
  mobileFallback: [enableProgressSync, enableArrowScrollSync],
  parentSelector: '[data-slider-parent]',
});
